// extracted by mini-css-extract-plugin
export default {"page":"statement_page__yDd5y"};